//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GameMode, MAX_MULTIPLIERS ,GameStatus , BetType  } from './enum';
/*import BuySkinComponent from '@app/modules/items/components/buy-skin/buy-skin.component.vue';
import PreloadRectComponent from '@app/@core/common/directives/preload-rect.vue';
import InventoryComponent from '../inventory/inventory.component.vue';*/

export default {
  name: 'BetComponent',
  components: {
    //BuySkin: BuySkinComponent,
    //PreloadRect: PreloadRectComponent,
    //Inventory: InventoryComponent
  },
  props: {
    // 装备库存列表
    sortedInventory: {
      type: Array,
      default: () => []
    },
    // 已选择的物品 ID 集合
    selectedIds: {
      type: Array,
      default: () => []
    },
    // 最大可选数量
    maxSelectableItems: {
      type: Number,
      default: 3
    },
    // 用户登录状态
    isAuthenticated: {
      type: Boolean,
      default: false
    },
    // 当前游戏状态 (如 'WON', 'LOST')
    currentGameStatus: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isLoading: false,
      isInventoryOpened: false,
      isMarketOpened: false,
      scrollIndicatorPosition: 0,
      hasScroll: false,
      isLg: false
    };
  },
  computed: {
    hasItems() {
      return this.sortedInventory && this.sortedInventory.length > 0;
    },
    limitReached() {
      return this.selectedIds.length >= this.maxSelectableItems;
    }
  },
  watch: {
    currentGameStatus(newStatus) {
      // 游戏结束结算时重新加载背包
      if (newStatus === 'WON' || newStatus === 'LOST') {
        if (this.isAuthenticated) {
          this.loadInventory();
        }
      }
    }
  },
  mounted() {
    this.checkIsLg();
    window.addEventListener('resize', this.handleResize);

    this.$nextTick(() => {
      this.updateScrollIndicator();
    });

    if (this.isAuthenticated) {
      this.loadInventory();
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.checkIsLg();
      this.updateScrollIndicator();
    },
    checkIsLg() {
      this.isLg = window.innerWidth <= 1024;
    },
    onScroll(event) {
      this.calculateScrollPosition(event.target);
    },
    calculateScrollPosition(container) {
      if (!container) return;

      const scrollLeft = container.scrollLeft;
      const scrollWidth = container.scrollWidth;
      const clientWidth = container.clientWidth;
      const maxScroll = scrollWidth - clientWidth;

      this.hasScroll = maxScroll > 0;

      if (maxScroll <= 0) {
        this.scrollIndicatorPosition = 0;
        return;
      }

      const indicatorContainer = this.$refs.indicatorContainer;
      const indicator = this.$refs.scrollIndicator;

      if (!indicatorContainer || !indicator) return;

      const scrollPercentage = scrollLeft / maxScroll;
      const containerWidth = indicatorContainer.offsetWidth;
      const indicatorWidth = indicator.offsetWidth;
      const maxPosition = containerWidth - indicatorWidth;

      const position = scrollPercentage * maxPosition;
      this.scrollIndicatorPosition = Math.max(0, Math.min(position, maxPosition));
    },
    updateScrollIndicator() {
      const container = this.$refs.scrollContainer;
      if (container) {
        this.calculateScrollPosition(container);
      }
    },
    loadInventory() {
      this.isLoading = true;
      // 触发外部加载逻辑
      this.$emit('load-inventory', () => {
        this.isLoading = false;
        this.$nextTick(() => this.updateScrollIndicator());
      });

      // 模拟兜底逻辑
      setTimeout(() => {
        this.isLoading = false;
        this.$nextTick(() => this.updateScrollIndicator());
      }, 300);
    },
    toggleInventory() {
      this.isInventoryOpened = !this.isInventoryOpened;
    },
    toggleMarket() {
      this.isMarketOpened = !this.isMarketOpened;
    },
    toggleSelectedInvItem(invItem, isSelected) {
      if (isSelected) {
        this.$emit('select-item', invItem);
      } else {
        this.$emit('unselect-item', invItem);
      }
    },
    isItemSelected(invItem) {
      return this.selectedIds.includes(invItem.id);
    },
    isItemDisabled(invItem) {
      return this.limitReached && !this.isItemSelected(invItem);
    },
    getItemImageUrl(id, size) {
      return `/api/items/${id}/image?size=${size}`;
    }
  }
};
